import React from 'react';
import PropTypes from 'prop-types';
import { styled, StyleSheet } from '@rexlabs/styling';
import Box from '@rexlabs/box';

import _ from 'lodash';
import colorTheme from '../../../utils/color-theme';
import { LargeButton } from '../../button';
import charLimit, { limits } from '../../../utils/char-limit';
import ScaledText from '../../scaled-text';
import GooText from '../../goo-text';
import { COLORS } from 'src/theme';

const fontFamily = 'Lato, sans-serif';
const defaultStyles = StyleSheet({
  topBanner: {
    width: '930px',
    height: '180px',
    border: '1px solid darkgray',
    overflow: 'hidden',
    display: 'flex'
  },
  primaryImage: {
    width: '332px',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  longHeadlineWrapper: {
    maxWidth: '170px',
    margin: '12px 6px'
  },
  longHeadline: {
    fontSize: '16px',
    fontWeight: 500,
    fontFamily,
    lineHeight: 1.7,
    color: `${COLORS.BLACK}`
  },
  main: {
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '0 30px',
    flex: 1
  },
  smallText: {
    fontFamily,
    fontSize: '14px',
    lineHeight: '15px',
    textTransform: 'uppercase',
    marginBottom: '8px'
  },
  shortHeadline: {
    fontFamily,
    fontWeight: 300,
    fontSize: '32px',
    lineHeight: '38px',
    marginBottom: '16px'
  },
  logoWrapper: {
    width: '160px',
    height: '100%',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  logo: {
    maxWidth: 'calc(0.75 * 155px)',
    maxHeight: 'calc(0.4 * 180px)',
    objectFit: 'contain'
  }
});

TopBanner.propTypes = {
  bannerAdText: PropTypes.string,
  shortHeadline: PropTypes.string,
  longHeadline: PropTypes.string,
  butonText: PropTypes.string,
  brandColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  primaryImageUrls: PropTypes.object,
  logoUrls: PropTypes.object
};

function TopBanner({
  buttonText = 'View Property',
  smallText,
  shortHeadline,
  primaryImageUrls,
  logoUrls,
  brandColor,
  backgroundColor,
  longHeadline,
  styles: s
}) {
  const { brandColorBorder } = colorTheme(brandColor);

  return (
    <Box {...s('topBanner')}>
      <Box
        {...s.with('primaryImage')({
          backgroundImage: `url('${_.get(primaryImageUrls, [
            'crop.landscape',
            'url'
          ])}')`
        })}
      >
        <Box {...s('longHeadlineWrapper')}>
          <GooText padding='6px 8px 4px' borderRadius={2}>
            <ScaledText
              maxWidth={170}
              maxTextLines={2}
              maxFontSize={16}
              minFontSize={12}
              {...s('longHeadline')}
            >
              {longHeadline}
            </ScaledText>
          </GooText>
        </Box>
      </Box>
      <Box {...s('main')}>
        <span {...s.with('smallText')({ color: COLORS.BLACK })}>
          {charLimit(smallText, limits.SMALL_TEXT)}
        </span>
        <ScaledText
          maxWidth={355}
          maxTextLines={2}
          maxFontSize={34}
          minFontSize={20}
          {...s.with('shortHeadline')({ color: COLORS.BLACK })}
        >
          {shortHeadline}
        </ScaledText>
        <Box width={134}>
          <LargeButton brandColor={brandColor}>{buttonText}</LargeButton>
        </Box>
      </Box>
      <Box
        {...s.with('logoWrapper')({
          backgroundColor: backgroundColor,
          borderLeft: brandColorBorder
        })}
      >
        <img src={_.get(logoUrls, 'original.url')} {...s('logo')} />
      </Box>
    </Box>
  );
}

export default styled(defaultStyles)(TopBanner);
